import React, { useState, useEffect } from "react";
import "../../style/AppPages.css";
import "../../style/FormStyles.css";
import "../../style/Update.css";
import OrderHistoryCompoment from "../../components/OrderHistoryComponent";
import { updateShippingAddressWithKey, setDefaultShippingAddressWithKey, removeAddressAtKey, addShippingAddressBD, fetchStripeUserData, getOrderHistory, logoutAccount, updateAccountEmail, updateAccountPassword, updateUserPreferences, fetchUserDataFromBd } from "../../controllers/AccountConnectionLayer";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { notifyError, notifySuccess } from "../../controllers/Toaster";
import useViewport from '../../hooks/useViewport';
import Loading from '../../components/Loading';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { CountrySelect, StateSelect, GetCountries, GetState } from 'react-country-state-city';
import { useTranslation } from 'react-i18next';
  
const UpdatePage = () => {
    const { user } = useAuth();
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const initialTab = location.state?.tab || "account";
    const [activeTab, setActiveTab] = useState(initialTab);
    const [orders, setOrders] = useState([]);
    const { isSmallView } = useViewport();
    const [userData, setUserData] = useState(null);
    const [stripeUserData, setStripeUserData] = useState(null);

    const [showPasswordEmailChange, setShowPasswordEmailChange] = useState(false);
    const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
    const [showPasswordNew, setShowPasswordNew] = useState(false);

    const [loading, setLoading] = useState(true);

    const [subscribeNewsletter, setSubscribeNewsletter] = useState(false);
    const [enableTwoFactor, setEnableTwoFactor] = useState(false);
    const [enableFantasyMode, setEnableFantasyMode] = useState(false);

    const [shippingFirstName, setShippingFirstName] = useState("");
    const [shippingLastName, setShippingLastName] = useState("");
    const [shippingPhone, setShippingPhone] = useState("");
    const [shippingLine1, setShippingLine1] = useState("");
    const [shippingLine2, setShippingLine2] = useState("");
    const [shippingCity, setShippingCity] = useState("");
    const [shippingCountry, setShippingCountry] = useState("");
    const [shippingProvince, setShippingProvince] = useState("");
    const [shippingZip, setShippingZip] = useState("");

    const [selectedAddress, setSelectedAddresses] = useState(null);
    const [allAddresses, setAllAddresses] = useState(null);

    const [editAddressMode, setEditAddressMode] = useState(false);
    const [edittingModeKey, setEdittingModeKey] = useState(null);
    const [addAddressMode, setAddAddressMode] = useState(false);

    const [shippingCountrySelect, setShippingCountrySelect] = useState(null);
    const [shippingProvinceSelect, setShippingProvinceSelect] = useState(null);

    const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, '');
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 10);
    
    if (digits.length <= 3) return part1;
    if (digits.length <= 6) return `${part1}-${part2}`;
    return `${part1}-${part2}-${part3}`;
    };
      

    const AddressCard = ({ address, onEdit, isDefault, removeAddress, setAsDefault }) => {
        const fullName = 
          (address.firstName && address.lastName) 
            ? `${address.firstName} ${address.lastName}` 
            : address.name || '';

        return (
          <div className="address-card">
            <div className="form-field">
              <label>{t("update.nameLabel")}:</label>
              <span>{fullName}</span>
            </div>
            <div className="form-field">
              <label>{t("update.phoneLabel")}:</label>
              <span>{address.phone || ''}</span>
            </div>
            <div className="form-field">
              <label>{t("update.addressLabel")}:</label>
              <span>{address.line1 || address.address?.line1 || ''}</span>
            </div>
            {(address.line2 || address.address?.line2) && (
              <div className="form-field">
                <label>{t("update.appartmentLabel")}:</label>
                <span>{address.line2 || address.address?.line2 || ''}</span>
              </div>
            )}
            <div className="form-field">
              <label>{t("update.countryLabel")}:</label>
              <span>{address.country || address.address?.country || ''}</span>
            </div>
            <div className="form-field">
              <label>{t("update.cityLabel")}:</label>
              <span>{address.city || address.address?.city || ''}</span>
            </div>
            <div className="form-field">
              <label>{t("update.provinceLabel")}:</label>
              <span>{address.province || address.address?.state || ''}</span>
            </div>
            <div className="form-field">
              <label>{t("update.postalCodeLabel")}:</label>
              <span>{address.zip || address.address?.postal_code || ''}</span>
            </div>
            {!isDefault && (
              <div>
                <button onClick={() => onEdit(address)}>{t("update.editAddressButton")}</button>
                <button onClick={() => setAsDefault(address)}>
                {t("update.setDefaultButton")}
                </button>
                <button onClick={() => removeAddress(address)}>{t("update.removeAddressButton")}</button>
              </div>
            )}
          </div>
        );
      };
      
    useEffect(() => {
        async function fetchUserData() {
            if (user) {
                const data = await fetchUserDataFromBd(user.id); // Pass user ID
                const stripeData = await fetchStripeUserData(data.stripe_id, t);

                setUserData(data);
                setStripeUserData(stripeData);
            }
        }
        fetchUserData();
    }, [user]);

    useEffect(() => {
        if (userData) {
            setSubscribeNewsletter(userData.subscribed);
            setEnableTwoFactor(userData.twoFactor);
            setEnableFantasyMode(userData.fantasy);
        }
    }, [userData]);

    const isEmptyAddress = (address) => {
        if (!address) return true;
        
        // Check all relevant fields
        const { address: addr, name, phone } = address;
        return (
          !name &&
          !phone &&
          (!addr || (
            !addr.city &&
            !addr.country &&
            !addr.line1 &&
            !addr.line2 &&
            !addr.postal_code &&
            !addr.state
          ))
        );
      };

    useEffect(() => {
        if (stripeUserData) {
            const shippingData = stripeUserData?.data?.customer?.shipping;

            const allOtherAddresses = stripeUserData?.data?.customer?.metadata;

            if (!isEmptyAddress(stripeUserData?.data?.customer?.shipping)) {
                setSelectedAddresses(stripeUserData?.data?.customer?.shipping);
            } else {
            setSelectedAddresses(null);
            }

            const parsedAddresses = parseAllAddresses(allOtherAddresses);
            
            setAllAddresses(parsedAddresses);
        }
    }, [stripeUserData])

    useEffect(() => {
        async function fetchOrders() {
            const orderData = await getOrderHistory();
            setOrders(orderData.data);
            setLoading(false);
        }
        fetchOrders();
    }, [userData, stripeUserData]);

    const changeDefaultShippingAddress = async (addressKey
        ) => {
        const response = await setDefaultShippingAddressWithKey(addressKey, userData.stripe_id, t);

        if (response && response.success){
            notifySuccess(response.message);
            const updatedUserData = await fetchUserDataFromBd(user.id);
            const updatedStripeData = await fetchStripeUserData(updatedUserData.stripe_id, t);
            setUserData(updatedUserData);
            setStripeUserData(updatedStripeData);
        }
    }

    const addShippingAddress = async (firstName,
        lastName,
        phone,
        line1,
        line2,
        city,
        country,
        province,
        zip) => {
            
        if (!firstName || !lastName || !phone || !phone || !line1 || !city || !country  || !province || !zip){
            notifyError(t("update.fillAllLabels"));
            return;
        }

        const response = await addShippingAddressBD(
            firstName,
            lastName,
            phone,
            line1,
            line2,
            city,
            country,
            province,
            zip,
            user.email,
            userData.stripe_id,
            t
        );

        if (response && !response.success){
            notifyError(response.message);
        }

        setAddAddressMode(false);
        
        if (response && response.success){
            notifySuccess(response.message);
            return response.data;
        }
    }

    const handleSaveShippingPreferences = async (e) => {
        e.preventDefault();
        
        const firstName = e.target.firstName.value;
        const lastName = e.target.lastName.value;

        const phone = e.target.phone.value;
        const line1 = e.target.line1.value;
        const line2 = e.target.line2.value;
        const city = e.target.city.value;
        const country = shippingCountry;
        const province = shippingProvince;
        const zip = e.target.zip.value;

        const response = await updateShippingAddressWithKey(edittingModeKey, firstName, lastName, phone, line1, line2, city, country, province, zip, userData.stripe_id, t);

        if (response && response.success){
            notifySuccess(response.message);
            const updatedUserData = await fetchUserDataFromBd(user.id);
            const updatedStripeData = await fetchStripeUserData(updatedUserData.stripe_id, t);
            setUserData(updatedUserData);
            setStripeUserData(updatedStripeData);
        }

        setEditAddressMode(false);
    }

    const parseAllAddresses = (metadata) => {
        const parsedArray = [];
        
        for (const key in metadata) {
            const jsonObject = Object.fromEntries(
                metadata[key].split(',').map(pair => pair.split(':'))
            );

            parsedArray.push({key: key, data: jsonObject});
        }
        
        return parsedArray;
    };

    useEffect(() => {
        const setCountry = () => {
            setShippingCountry(shippingCountrySelect?.name);
        }
        setCountry();
    }, [shippingCountrySelect]);

    useEffect(() => {
        const setProvince = () => {
            setShippingProvince(shippingProvinceSelect?.name);
        }
        setProvince();
    }, [shippingProvinceSelect]);

    const handleAddShippingAddressPreferences = async (e) => {
        e.preventDefault();
        
        const firstName = e.target.firstName.value;
        const lastName = e.target.lastName.value;

        const phone = e.target.phone.value;
        const line1 = e.target.line1.value;
        const line2 = e.target.line2.value;
        const city = e.target.city.value;
        const country = shippingCountry;
        const province = shippingProvince;
        const zip = e.target.zip.value;

        await addShippingAddress(firstName, lastName, phone, line1, line2, city, country, province, zip);

        if (stripeUserData && stripeUserData.data){
            const updatedUserData = await fetchUserDataFromBd(user.id);
            const updatedStripeData = await fetchStripeUserData(updatedUserData.stripe_id, t);
            setUserData(updatedUserData);
            setStripeUserData(updatedStripeData);
        }
    }

    const handleSaveUserInfo = async (e) => {
        e.preventDefault();

        const currentEmail = user.email;
        const newEmail = e.target.email.value;
        const password = e.target.password.value;

        if (!currentEmail || !newEmail || !password) {
            notifyError(t("update.fillAllLabels"));
            return;
        }
        
        const response = await updateAccountEmail({currentEmail, newEmail, password }, t);

        if (response && response.success){
            notifySuccess(response.message);
            await logoutAccount(() => navigate("/account/login"));
        }
    };

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        
        const email = e.target.email.value; 
        const currentPassword = e.target.currentPassword.value;
        const newPassword = e.target.newPassword.value;
        
        if (!email || !currentPassword || !newPassword) {
            notifyError(t("update.fillAllLabels"));
            return;
        }
    
        const response = await updateAccountPassword({email, currentPassword, newPassword}, t);

        if (response && response.success){
            notifySuccess(response.message);
            await logoutAccount(() => navigate("/account/login"));
        }
    }

    const handleSavePreferences = async (e) => {
        e.preventDefault();

        const subscribeNewsletter = e.target.newsletter.checked;
        // const enableTwoFactor = e.target.twoFactor.checked;
        const enableTwoFactor = true;
        const enableFantasyMode = e.target.fantasyMode.checked;
        const response = await updateUserPreferences(user.id, user.email, subscribeNewsletter, enableTwoFactor, enableFantasyMode, t);

        if (response && response.success){
            notifySuccess(t("toast.preferecesSuccess"));
        }
    };

    const handleEditAddress = (addressData) => {
        const address = addressData.data;
        if (address.name){
            const splitName = address.name.split(/(\s+)/);
            setShippingFirstName(splitName[0]);
            setShippingLastName(splitName[2]);
        }
        else{
            setShippingFirstName(address.firstName);
            setShippingLastName(address.lastName);
        }

        setShippingPhone(address.phone);

        var shippingAddress = address;

        if (address.address){
            shippingAddress = address.address;
        }

        setShippingLine1(shippingAddress.line1);
        setShippingLine2(shippingAddress.line2);
        setShippingCity(shippingAddress.city);

        setShippingCountry(shippingAddress.country);

        var country = null;
        GetCountries().then((result) => {
            country = result.find(country => country.name.toLowerCase() === shippingAddress.country.toLowerCase());
            setShippingCountrySelect(country);

            GetState(country.id).then((states) => {
                const provinceName = shippingAddress.state || shippingAddress.province;
                const matchedState = states.find(
                    (s) => s.name.toLowerCase() === provinceName?.toLowerCase()
                );
    
                setShippingProvinceSelect(matchedState);
            });
        });

        setShippingProvince(shippingAddress.state || shippingAddress.province);

        setShippingZip(shippingAddress.postal_code || shippingAddress.zip);

        setEdittingModeKey(addressData.key);
        setEditAddressMode(true);
    };

    useEffect(() => {
            if (shippingCountrySelect)
              GetState(parseInt(shippingCountrySelect.id)).then((result) => {
                const state = result.find(state => state.name.toLowerCase() === shippingProvince?.toLowerCase());
                setShippingProvinceSelect(state);
              });
          }, [shippingCountrySelect]);
    

    const handleRemoveAddress = async (addressKey) => {
        const response = await removeAddressAtKey(addressKey, userData.stripe_id, t);

        if (response && response.success){
            const updatedUserData = await fetchUserDataFromBd(user.id);
            const updatedStripeData = await fetchStripeUserData(updatedUserData.stripe_id, t);
            setUserData(updatedUserData);
            setStripeUserData(updatedStripeData);
        }
    }
    
    const handleCancelEdit = () => {
        setEditAddressMode(false);
    };

    const handleAddAddress = () => {
        setShippingFirstName("");
        setShippingLastName("");
        setShippingPhone("");
        setShippingLine1("");
        setShippingLine2("");
        setShippingCity("");
        setShippingCountry("");
        setShippingProvince("");
        setShippingZip("");
        setShippingCountrySelect(null);
        setShippingProvinceSelect(null);
        
        setAddAddressMode(true);
    };
    
    const handleCancelAdd = () => {
        setAddAddressMode(false);
    };

    const handleCancelAllEdit = () => {
        setEditAddressMode(false);
        setAddAddressMode(false);
    };

    const handleTabClick = (newTab) => {
        setActiveTab(newTab);
        navigate('/account/update', { state: { tab: newTab } });
      };

    return (
        <>
        <Loading isVisible={loading} />
            <div className="page-padding account-update-page">
                <div className="tabs-container make-smaller make-set-size">
                    <button 
                        className={`tab-button ${activeTab === "account" ? "active" : ""}`} 
                        onClick={() => handleTabClick("account")}
                    >
                        <span>{t("update.accountDetailsLabel")}</span>
                    </button>
                    <button 
                        className={`tab-button ${activeTab === "orders" ? "active" : ""}`} 
                        onClick={() => handleTabClick("orders")}
                    >
                        
                        <span>{t("update.orderHistoryLabel")}</span>
                    </button>
                </div>

                <div className="account-update-container make-smaller make-set-size">
                    
                    {activeTab === "account" && (
                        <div>
                            <h1>{t("update.updateTitle")}</h1>
                            <div class="account-inner-section">
                                {/* Address Update Section */}
                                {!isSmallView && (
                                    <div>
                                        {editAddressMode || addAddressMode ? (
                                            <form 
                                            className="preferences-container" 
                                            onSubmit={editAddressMode ? handleSaveShippingPreferences : handleAddShippingAddressPreferences}
                                            >
                                                <div className="address-update-section">
                                                {editAddressMode ? (
                                                        <h2>{t("update.updateEditText")}</h2>
                                                    ) : (
                                                        <h2>{t("update.updateAddText")}</h2>
                                                    )}
                                                    
                                                    <div className="name-fields">
                                                        <div className="form-field">
                                                            <label htmlFor="firstName">{t("update.firstNameLabel")}</label>
                                                            <input type="text" id="firstName" name="firstName" placeholder={t("update.firstNameLabel")} 
                                                            value={shippingFirstName} 
                                                            onChange={(e) => setShippingFirstName(e.target.value)}
                                                            required />
                                                        </div>
                                                        <div className="form-field">
                                                            <label htmlFor="lastName">{t("update.lastNameLabel")}</label>
                                                            <input type="text" id="lastName" name="lastName" placeholder={t("update.lastNameLabel")} 
                                                            value={shippingLastName} 
                                                            onChange={(e) => setShippingLastName(e.target.value)}
                                                            required />
                                                        </div>
                                                    </div>

                                                    <div className="form-field">
                                                        <label htmlFor="phone">{t("update.phoneLabel")}</label>
                                                        <input type="tel" id="phone" name="phone" placeholder={t("update.phoneLabel")} 
                                                        value={formatPhoneNumber(shippingPhone)} 
                                                        onChange={(e) => {
                                                            const digitsOnly = e.target.value.replace(/\D/g, '');
                                                            setShippingPhone(digitsOnly);
                                                          }}
                                                        required />
                                                    </div>

                                                    <div className="form-field">
                                                        <label htmlFor="line1">{t("update.addressLabel")}</label>
                                                        <input type="text" id="line1" name="line1" placeholder={t("update.addressLabel")} 
                                                        value={shippingLine1} 
                                                        onChange={(e) => setShippingLine1(e.target.value)}
                                                        required />
                                                    </div>

                                                    <div className="form-field">
                                                        <label htmlFor="line2">{t("update.appartmentLabel")}</label>
                                                        <input type="text" id="line2" name="line2" placeholder={t("update.appartmentLabel")} 
                                                        value={shippingLine2} 
                                                        onChange={(e) => setShippingLine2(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="form-field">
                                                        <label htmlFor="country">{t("update.countryLabel")}</label>
                                                        <CountrySelect
                                                        id="country"
                                                        placeHolder={t("update.countryLabel")}
                                                        onChange={(_country) => setShippingCountrySelect(_country)}
                                                        defaultValue={shippingCountrySelect}
                                                        required
                                                        />
                                                    </div>

                                                    <div className="form-field">
                                                        <label htmlFor="province">{t("update.provinceLabel")}</label>
                                                        <StateSelect 
                                                            countryid={shippingCountrySelect?.id}
                                                            id="destinationProvince"
                                                            placeHolder={t("update.provinceLabel")}
                                                            inputClassName=""
                                                            onChange={(_state) => setShippingProvinceSelect(_state)}
                                                            defaultValue={shippingProvinceSelect}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="form-field">
                                                        <label htmlFor="city">{t("update.cityLabel")}</label>
                                                        <input type="text" id="city" name="city" placeholder={t("update.cityLabel")} 
                                                        value={shippingCity} 
                                                        onChange={(e) => setShippingCity(e.target.value)}
                                                        required />
                                                    </div>

                                                    <div className="form-field">
                                                        <label htmlFor="zip">{t("update.postalCodeLabel")}</label>
                                                        <input type="text" id="zip" name="zip" placeholder={t("update.postalCodeLabel")} 
                                                        value={shippingZip} 
                                                        onChange={(e) => {
                                                            setShippingZip(e.target.value);
                                                        }}
                                                        required />
                                                    </div>

                                                    {editAddressMode ? (
                                                        <button type="submit">{t("update.updateAddressLabel")}</button>
                                                    ) : (
                                                        <button type="submit">{t("update.saveNewAddressLabel")}</button>
                                                    )}
                                                    
                                                    <button type="button" onClick={handleCancelAllEdit}>{t("update.cancelButton")}</button>
                                                </div>
                                            </form>
                                        ) : (
                                            <div className="preferences-container-left">
                                                <div className="address-update-section">
                                                    <div className="address-book-header">
                                                        <h2>{t("update.addressBook")}</h2>
                                                        <button className="add-address-button" onClick={handleAddAddress}>{t("update.addressBookAddText")}</button>
                                                    </div>
                                                    {selectedAddress && (
                                                        <div>
                                                            <h3>{t("update.defaultAddressLabel")}</h3>
                                                            <AddressCard 
                                                                address={selectedAddress} 
                                                                onEdit={() => handleEditAddress(selectedAddress)} 
                                                                isDefault={true} 
                                                            />
                                                        </div>
                                                    )}
                                                    
                                                    {allAddresses?.length > 0 ? (
                                                        <>
                                                            <h3>{t("update.savedAddressLabel")}</h3>
                                                            {allAddresses.map((address) => (
                                                            <AddressCard
                                                                key={address.key}
                                                                address={address.data}
                                                                onEdit={() => handleEditAddress(address)}
                                                                isDefault={false}
                                                                removeAddress={() => handleRemoveAddress(address.key)}
                                                                setAsDefault={() => changeDefaultShippingAddress(address.key)}
                                                            />
                                                            ))}
                                                        </>
                                                        ) : !selectedAddress && (
                                                        <p>{t("update.addressBookAddTextLabel")}</p>
                                                        )}
                                                </div>

                                            </div>
                                        )}
                                    </div>
                                )}

                                <div>
                                    {/* Preferences Section */}
                                    <form className="preferences-container" onSubmit={handleSavePreferences}>
                                        <div className="preferences-section">
                                            <h2>{t("update.preferencesLabel")}</h2>
                                            <div className="option-field">
                                                <label>{t("update.subscribeText")}</label>
                                                <input
                                                    type="checkbox"
                                                    id="newsletter"
                                                    name="newsletter"
                                                    checked={subscribeNewsletter}
                                                    onChange={(e) => setSubscribeNewsletter(e.target.checked)}
                                                />
                                            </div>

                                            {/* <div className="option-field">
                                                <label>Enable Two-Factor Verification</label>
                                                <input
                                                    type="checkbox"
                                                    id="twoFactor"
                                                    name="twoFactor"
                                                    checked={enableTwoFactor}
                                                    onChange={(e) => setEnableTwoFactor(e.target.checked)}
                                                />
                                            </div> */}

                                            <div className="option-field">
                                                <label>{t("update.fantasyText")}</label>
                                                <input
                                                    type="checkbox"
                                                    id="fantasyMode"
                                                    name="fantasyMode"
                                                    checked={enableFantasyMode}
                                                    onChange={(e) => setEnableFantasyMode(e.target.checked)}
                                                />
                                            </div>

                                            <button type="submit" className="save-settings-button">
                                                {t("update.savePreferencesButton")}
                                            </button>
                                        </div>
                                    </form>

                                    {isSmallView && (
                                        <div>
                                            {editAddressMode || addAddressMode ? (
                                                <form 
                                                className="preferences-container" 
                                                onSubmit={editAddressMode ? handleSaveShippingPreferences : handleAddShippingAddressPreferences}
                                                >
                                                    <div className="preferences-section">
                                                    {editAddressMode ? (
                                                            <h2>{t("update.updateEditText")}</h2>
                                                        ) : (
                                                            <h2>{t("update.updateAddText")}</h2>
                                                        )}
                                                        
                                                        {/* <div className="name-fields"> */}
                                                            <div className="form-field">
                                                                <label htmlFor="firstName">{t("update.firstNameLabel")}</label>
                                                                <input type="text" id="firstName" name="firstName" placeholder={t("update.firstNameLabel")} 
                                                                value={shippingFirstName} 
                                                                onChange={(e) => setShippingFirstName(e.target.value)}
                                                                required />
                                                            </div>
                                                            <div className="form-field">
                                                                <label htmlFor="lastName">{t("update.lastNameLabel")}</label>
                                                                <input type="text" id="lastName" name="lastName" placeholder={t("update.lastNameLabel")} 
                                                                value={shippingLastName} 
                                                                onChange={(e) => setShippingLastName(e.target.value)}
                                                                required />
                                                            </div>
                                                        {/* </div> */}

                                                        <div className="form-field">
                                                            <label htmlFor="phone">{t("update.phoneLabel")}</label>
                                                            <input type="tel" id="phone" name="phone" placeholder={t("update.phoneLabel")} 
                                                            value={formatPhoneNumber(shippingPhone)} 
                                                            onChange={(e) => {
                                                                const digitsOnly = e.target.value.replace(/\D/g, '');
                                                                setShippingPhone(digitsOnly);
                                                            }}
                                                            required />
                                                        </div>

                                                        <div className="form-field">
                                                            <label htmlFor="line1">{t("update.addressLabel")}</label>
                                                            <input type="text" id="line1" name="line1" placeholder={t("update.addressLabel")} 
                                                            value={shippingLine1} 
                                                            onChange={(e) => setShippingLine1(e.target.value)}
                                                            required />
                                                        </div>

                                                        <div className="form-field">
                                                            <label htmlFor="line2">{t("update.appartmentLabel")}</label>
                                                            <input type="text" id="line2" name="line2" placeholder={t("update.appartmentLabel")} 
                                                            value={shippingLine2} 
                                                            onChange={(e) => setShippingLine2(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="form-field">
                                                            <label htmlFor="country">{t("update.countryLabel")}</label>
                                                            <input type="text" id="country" name="country" placeholder={t("update.countryLabel")} 
                                                            value={shippingCountry} 
                                                            onChange={(e) => setShippingCountry(e.target.value)}
                                                            required />
                                                        </div>

                                                        <div className="form-field">
                                                            <label htmlFor="province">{t("update.provinceLabel")}</label>
                                                            <input type="text" id="province" name="province" placeholder={t("update.provinceLabel")} 
                                                            value={shippingProvince} 
                                                            onChange={(e) => setShippingProvince(e.target.value)}
                                                            required />
                                                        </div>

                                                        <div className="form-field">
                                                            <label htmlFor="city">{t("update.cityLabel")}</label>
                                                            <input type="text" id="city" name="city" placeholder={t("update.cityLabel")} 
                                                            value={shippingCity} 
                                                            onChange={(e) => setShippingCity(e.target.value)}
                                                            required />
                                                        </div>

                                                        <div className="form-field">
                                                            <label htmlFor="zip">{t("update.postalCodeLabel")}</label>
                                                            <input type="text" id="zip" name="zip" placeholder={t("update.postalCodeLabel")} 
                                                            value={shippingZip} 
                                                            onChange={(e) => {
                                                                setShippingZip(e.target.value)
                                                                }
                                                            }
                                                            required />
                                                        </div>

                                                        {editAddressMode ? (
                                                            <button type="submit">{t("update.updateAddressLabel")}</button>
                                                        ) : (
                                                            <button type="submit">{t("update.saveNewAddressLabel")}</button>
                                                        )}
                                                        
                                                        <button type="button" onClick={handleCancelAllEdit}>{t("update.cancelButton")}</button>
                                                    </div>
                                                </form>
                                            ) : (
                                                <div className="preferences-container">
                                                    <div className="preferences-section">
                                                        <div className="address-book-header">
                                                            <h2>{t("update.addressBook")}</h2>
                                                            <button className="add-address-button" onClick={handleAddAddress}>{t("update.addressBookAddText")}</button>
                                                        </div>
                                                        {selectedAddress && (
                                                            <div>
                                                                <h3>{t("update.defaultAddressLabel")}</h3>
                                                                <AddressCard 
                                                                    address={selectedAddress} 
                                                                    onEdit={() => handleEditAddress(selectedAddress)} 
                                                                    isDefault={true} 
                                                                />
                                                            </div>
                                                        )}
                                                        
                                                        {allAddresses?.length > 0 ? (
                                                            <>
                                                                <h3>{t("update.savedAddressLabel")}</h3>
                                                                {allAddresses.map((address) => (
                                                                <AddressCard
                                                                    key={address.key}
                                                                    address={address.data}
                                                                    onEdit={() => handleEditAddress(address)}
                                                                    isDefault={false}
                                                                    removeAddress={() => handleRemoveAddress(address.key)}
                                                                    setAsDefault={() => changeDefaultShippingAddress(address.key)}
                                                                />
                                                                ))}
                                                            </>
                                                            ) : !selectedAddress && (
                                                            <p>{t("update.addressBookAddTextLabel")}</p>
                                                            )}
                                                    </div>

                                                </div>
                                            )}
                                        </div>
                                )}
    
                                    {/* User Information Section */}
                                    <form className="preferences-container" onSubmit={handleSaveUserInfo}>
                                        <div className="preferences-section">
                                            <h2>{t("update.emailChangeTitle")}</h2>
                                            <div className="form-field">
                                                <label htmlFor="email">{t("update.newEmailLabel")}</label>
                                                <input type="email" id="email" name="email" placeholder={t("update.newEmailLabel")} required/>
                                            </div>

                                            <div className="form-field">
                                                <label htmlFor="password">{t("update.passwordLabel")}</label>
                                                <div className="input-with-icon">
                                                    <input type={showPasswordEmailChange ? "text" : "password"} id="password" name="password" placeholder={t("update.passwordLabel")} required/>
                                                    <FontAwesomeIcon
                                                        icon={showPasswordEmailChange ? faEyeSlash : faEye}
                                                        className="eye-icon"
                                                        onClick={() => setShowPasswordEmailChange((prev => !prev))}
                                                    />
                                                </div>
                                            </div>

                                            <button type="submit" className="save-settings-button">
                                                {t("update.saveUserInfoLabel")}
                                            </button>
                                        </div>
                                    </form>

                                    {/* User Information Section */}
                                    <form className="preferences-container" onSubmit={handlePasswordUpdate}>
                                        <div className="preferences-section">
                                            <h2>{t("update.changePasswordButton")}</h2>

                                            <div className="form-field">
                                                <label htmlFor="email">{t("update.emailLabel")}</label>
                                                <input type="email" id="email" name="email" placeholder={t("update.emailLabel")} required />
                                            </div>

                                            <div className="form-field">
                                                <label htmlFor="password">{t("update.currentPasswordLabel")}</label>    
                                                <div className="input-with-icon">
                                                    <input type={showPasswordCurrent ? "text" : "password"} id="currentPassword" name="currentPassword" placeholder={t("update.currentPasswordLabel")} required></input>
                                                    <FontAwesomeIcon
                                                        icon={showPasswordCurrent ? faEyeSlash : faEye}
                                                        className="eye-icon"
                                                        onClick={() => setShowPasswordCurrent((prev => !prev))}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-field">
                                                <label htmlFor="password">{t("update.newPasswordLabel")}</label>
                                                <div className="input-with-icon">
                                                    <input type={showPasswordNew ? "text" : "password"} id="newPassword" name="newPassword" placeholder={t("update.newPasswordLabel")} required />
                                                    <FontAwesomeIcon
                                                        icon={showPasswordNew ? faEyeSlash : faEye}
                                                        className="eye-icon"
                                                        onClick={() => setShowPasswordNew((prev => !prev))}
                                                    />
                                                </div>
                                            </div>

                                            <button type="submit" className="save-settings-button">
                                                {t("update.changePasswordButton")}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === "orders" && (
                        <div>
                            <h1>{t("update.orderHistoryLabel")}</h1>
                            {orders.length === 0 ? (
                                <p>{t("update.noOrdersLabel")}</p>
                            ) : (
                                <OrderHistoryCompoment orderItems={orders} page={"Update"}/>
                            )}
                        </div>
                    )}

                    <button className="form-button" onClick={() => logoutAccount(navigate)} >{t("account.logoutButtonLabel")}</button>
                </div>
            </div>
        </>
    );
};

export default UpdatePage;
